export const lottieRegistry = {
  arrow: () => import('../../assets/dark-green/Arrow.json'), //arrow-up-right
  chain_link: () => import('../../assets/dark-green/ChainLink.json'), //comments-question-check
  chat: () => import('../../assets/dark-green/Chat.json'), //comments-question-check
  clock_boost: () => import('../../assets/dark-green/ClockBoost.json'), //gauge-circle-bolt
  cloud: () => import('../../assets/dark-green/Cloud.json'), //sensor-cloud
  double_arrow: () => import('../../assets/dark-green/DoubleArrow.json'), //shuffle
  leaf: () => import('../../assets/dark-green/Leaf.json'), //seedling
  pie_chart: () => import('../../assets/dark-green/PiChart.json'), //chart-pie
  shield: () => import('../../assets/dark-green/Shield.json'),//shield-check
  world_map: () => import('../../assets/dark-green/WorldMap.json'), //globe
};
